import React, { useMemo, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'

import { Helmet } from 'react-helmet'

import { HydraTable, Heading, TextFilter, StyledCheckbox } from '@peracto/peracto-ui'

import { GET_LIST, useClient } from '@peracto/client'

const AttributeSetList = () => {
    const [selectedColumns, onSelectColumn] = useState({})
    const { client } = useClient()

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            id: 'selection',
            Header: ({ getToggleAllRowsSelectedProps }) => (
                <StyledCheckbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
                <StyledCheckbox
                    {...row.getToggleRowSelectedProps()}
                    data-testid={`row-${row.index}-checkbox`}
                />
            ),
            selectable: false,
        },
        {
            Header: 'Name',
            accessor: 'name',
            sortType: 'basic',
            Filter: props => <TextFilter label="Name" {...props} />,
            Cell: row => (
                <Link to={row.row.original.id} data-testid={`row-${row.row.index}-name`}>
                    {row.cell.value}
                </Link>
            ),
            selectable: false,
        },
        {
            Header: '# of Groups',
            accessor: 'groups',
            Cell: row => row.cell.value.length,
            disableSorting: true,
            selectable: false,
        },
    ])

    const onFetchData = options => client(GET_LIST, 'attribute-sets', options)

    return (
        <>
            <Helmet>
                <title>Attribute Sets | Peracto</title>
            </Helmet>
            <Heading name="Attribute Sets">
                <div className="!flex !items-center !ml-2">
                    <Link
                        className="btn btn-primary"
                        to="/attribute-sets/add"
                        data-testid="add-attribute-set"
                    >
                        <FontAwesomeIcon icon={faPlusCircle} className="!mr-2" />
                        Add Attribute Set
                    </Link>
                </div>
            </Heading>

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onFetchData={onFetchData}
                                onSelectColumn={onSelectColumn}
                                defaultFilters={{
                                    name: '',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AttributeSetList
